import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { GoldButton } from "./GoldButton";
import { Reveal, MaskedLine } from "./Reveal";

const BENEFITS = ["Gratuito per iniziare", "Nessuna carta richiesta", "Nessun obbligo di continuare"];

const STEPS = ["Entra", "Provalo", "Attraversa il Deserto", "Scopri il nostro metodo", "Scopri la nostra visione"];

export const Decision = () => (
  <section className="relative px-5 py-28 sm:px-8 lg:py-40" data-testid="decision-section">
    <div className="mx-auto max-w-5xl">
      <h2 className="font-display font-bold uppercase leading-[1.05] tracking-tight" data-testid="decision-headline">
        <MaskedLine className="text-4xl text-ivory sm:text-6xl">Prima 40 giorni.</MaskedLine>
        <MaskedLine delay={0.15} className="mt-2 text-4xl sm:text-6xl">
          <span className="text-gold">Poi decidi tu.</span>
        </MaskedLine>
      </h2>

      <Reveal delay={0.25} className="mt-10 max-w-2xl">
        <p className="text-base leading-relaxed text-ivory/60 sm:text-lg">Non devi fidarti sulla parola.</p>
      </Reveal>

      <div className="mt-8 flex flex-wrap gap-3" data-testid="decision-steps">
        {STEPS.map((s, i) => (
          <motion.span
            key={s}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 * i }}
            className="border border-ivory/15 px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-ivory/70"
          >
            {s}
          </motion.span>
        ))}
      </div>

      <Reveal delay={0.3} className="mt-8 max-w-2xl">
        <p className="text-base leading-relaxed text-ivory/60 sm:text-lg">
          E se al giorno 40 vorrai continuare, Tempio Vivo sarà lì ad aspettarti.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-px border border-ivory/10 bg-ivory/10 sm:grid-cols-3" data-testid="decision-benefits">
        {BENEFITS.map((b, i) => (
          <motion.div
            key={b}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            className="flex items-center gap-4 bg-night px-6 py-7"
          >
            <span className="flex h-8 w-8 shrink-0 items-center justify-center border border-gold/50">
              <Check className="h-4 w-4 text-gold" strokeWidth={2.5} />
            </span>
            <span className="font-display text-sm font-bold uppercase tracking-[0.14em] text-ivory">{b}</span>
          </motion.div>
        ))}
      </div>

      <Reveal delay={0.4} className="mt-14">
        <GoldButton testId="decision-cta-button" size="lg" />
      </Reveal>
    </div>
  </section>
);
